import { useRef, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import FormFields from "../components/FormFields";
import euserConfig from "../data/euserConfig"; // Form config
import { FormDataType } from "../types";
import useEuser from "../utils/useEuser"; // access to provider via "use" hook

export const AccountSignIn = () => {
  const { signInEuser, signInWithTempAuthCode } = useEuser();
  const isAutoSignIn = useRef(false);

  const navigate = useNavigate();

  const afterPostFunction = async () => {
    if (isAutoSignIn.current) {
      navigate("/account/edit");
    } else {
      navigate("/account/reservations");
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tempAuthCode = queryParams.get("tempAuthCode");

    if (tempAuthCode && signInWithTempAuthCode) {
      isAutoSignIn.current = true;
      const autoSignIn = async () => {
        try {
          await signInWithTempAuthCode(tempAuthCode);
          await afterPostFunction();
        } catch {
          // Clear query params
          window.history.pushState({}, document.title, "/account/signin");
        }
      };

      autoSignIn();
    }
  }, [location.search]);

  const [formData, setFormData] = useState<FormDataType>(
    euserConfig.signInFields.reduce(
      (prev, field) => ({
        ...prev,
        [field.fieldName]: "",
      }),
      {}
    )
  );

  return (
    <div className="editPageWrapper accountSignInPage">
      <h3 className="list_title">Sign In</h3>

      <div className="signInEuserWrapper">
        <FormFields
          fields={euserConfig.signInFields}
          form={{ method: "post", data: formData }}
          setFormData={(_, data) => setFormData(data)}
          formMode={"post"}
          name={euserConfig.name}
          onPostFunction={signInEuser}
          afterPostFunction={afterPostFunction}
        />
      </div>

      <div style={{ padding: "3em 0em 0em 0em" }}>
        <p>
          Forgot Password? <Link to="/account/recover">Recover Account</Link>
        </p>
      </div>
    </div>
  );
};
